var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chart-line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.833496 1.66634C0.833496 1.2061 1.20659 0.833008 1.66683 0.833008C2.12707 0.833008 2.50016 1.2061 2.50016 1.66634V16.6663C2.50016 17.1266 2.87326 17.4997 3.3335 17.4997L18.3335 17.4997C18.7937 17.4997 19.1668 17.8728 19.1668 18.333C19.1668 18.7932 18.7937 19.1663 18.3335 19.1663H2.50016C1.57969 19.1663 0.833496 18.4201 0.833496 17.4997V1.66634Z",
    fill: "#D80587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6072 4.47583C16.7782 4.04851 16.5703 3.56354 16.143 3.39261C15.7157 3.22168 15.2307 3.42953 15.0598 3.85685L12.3522 10.6258C12.2484 10.8854 11.9234 10.971 11.705 10.7964L9.23445 8.81992C8.63506 8.34041 7.74911 8.50937 7.36828 9.17583L4.27663 14.5862C4.04829 14.9858 4.18712 15.4949 4.58671 15.7232C4.98631 15.9516 5.49536 15.8127 5.7237 15.4131L8.33199 10.8486C8.45894 10.6265 8.75425 10.5701 8.95405 10.73L11.541 12.7995C12.196 13.3235 13.171 13.0665 13.4825 12.2877L16.6072 4.47583Z",
    fill: "#D80587"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLine);
export default __webpack_public_path__ + "static/media/chart-line.6f40141081c459baee97e916d428869b.svg";
export { ForwardRef as ReactComponent };